import axios from 'axios';
import config from '../config';
import * as Sentry from '@sentry/react';

export async function fetchTotalCompanies() {
  const apiURL = `${config.apiUrl}/ui/stats`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    const total = result.data.total_companies;
    const formatted = total.toLocaleString();
    return formatted;
  } else {
    Sentry.captureException(new Error('Error fetching total companies'));
  }
}

export async function fetchDemographics(mediacode, prodcode) {
  const paramsStr = new URLSearchParams({ prodcode, mediacode });
  const apiURL = `${config.apiUrl}/market/demographics?${paramsStr}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data.demographics;
  } else {
    Sentry.captureException(new Error('Error fetching demographics'));
  }
}

export async function fetchMedia(mediaCode) {
  const apiURL = `${config.apiUrl}/media/${mediaCode}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching media'));
  }
}

export async function fetchAllMediaByType(mediaType) {
  const apiURL = `${config.apiUrl}/media/type/${mediaType}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching media'));
  }
}

export async function fetchMediaByCode(code) {
  const apiURL = `${config.apiUrl}/media/${code}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching media'));
  }
}

// For example:
// https://api-qa.addy.co/api/v1/media/GATA/availability?prodcode=D-AZ-FLAG
export async function fetchAvailabilityByMediacode(mediacode, prodcode) {
  const searchParams = new URLSearchParams({ prodcode });
  const apiURL = `${config.apiUrl}/media/${mediacode}/availability?${searchParams}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching media'));
  }
}

// For example:
// https://api-qa.addy.co/api/v1/media/GATA/quote?prodcode=D-AZ-FLAG&qty=100000
export async function fetchQuotePdp(payload) {
  const searchParams = new URLSearchParams({
    ...payload,
  });
  const apiURL = `${config.apiUrl}/media/${payload.mediacode}/quote?${searchParams}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching media'));
  }
}

export async function fetchQuote(mediacode, zipcodes) {
  const searchParams = new URLSearchParams({
    mediacode,
    zipcodes: zipcodes.join(','),
  });
  const apiURL = `${config.apiUrl}/abdm/campaign/quote?${searchParams}`;
  const response = await axios.post(apiURL, {});
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching ABDM quote'));
  }
}

export async function fetchMarketBoundary(prodcode) {
  const searchParams = new URLSearchParams({ prodcode });
  const apiURL = `${config.apiUrl}/market/geo?${searchParams}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data.geo;
  } else {
    Sentry.captureException(new Error('Error fetching Market boundary'));
  }
}

export async function fetchMarketNearby(lat, lng, mediacode) {
  const searchParams = new URLSearchParams({ lat, lng, mediacode });
  const apiURL = `${config.apiUrl}/market/nearby?${searchParams}`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data.prodcode;
  } else {
    Sentry.captureException(new Error('Error fetching nearby market'));
  }
}

export async function fetchABDMRates() {
  const apiURL = `${config.apiUrl}/abdm/rates`;
  const response = await axios.get(apiURL);
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error fetching ABDM rates'));
  }
}

export async function createABDMCampaign(payload) {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const salesforceWebhook = `${config.salesforceWebhook}`;
    const response = await axios.post(salesforceWebhook, payload, headers);
    return response;
  } catch (err) {
    Sentry.captureException(
      new Error('Error while creating ABDM campaign in Salesforce'),
    );
  }
}

//mediacode, prodcode, dateStart, dateEnd, qty, cartId
export async function addItem(payload) {
  let formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });

  const apiURL = `${config.apiUrl}/checkout/item/create`;
  const response = await axios({
    method: 'post',
    url: apiURL,
    data: formData,
    headers: {
      'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
      Accept: 'application/json',
    },
  });
  const result = response.data;
  if (result.success) {
    return result.data;
  } else {
    Sentry.captureException(new Error('Error adding new item'));
  }
}
